import { toast } from 'react-hot-toast';
import axios from 'axios';

export default async function getAiReport(packId, testId, setGeneratingAiReport = () => {}) {
  try {
    setGeneratingAiReport(true);
    const response = await axios.get(`/api/test/${packId}/${testId}/ai-report`);
    const data = response?.data;

    if (data?.data) {
      window.open(data.data, '_blank')?.focus();
      setGeneratingAiReport(false);
      return data.data;
    }

    toast.success(
      <div className="flex flex-col items-start">
        <p>AI report generation started.</p>
        <p>You will receive it on your email when ready.</p>
      </div>,
      {
        position: 'top-center',
        duration: 1800,
      },
    );
    return null;
  } catch (error) {
    toast.error(error?.response?.data?.message || 'Something went wrong while generating the AI report.', {
      position: 'top-center',
      duration: 1000,
    });
    return null;
  } finally {
    setGeneratingAiReport(false);
  }
}
